module.exports = __webpack_public_path__ + "img/bookingerror.d153a57b.png";